import { render, staticRenderFns } from "./IdNameForm.vue?vue&type=template&id=2d6937d8"
import script from "./IdNameForm.vue?vue&type=script&lang=js"
export * from "./IdNameForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports